import React from "react";
import { useParams } from "react-router-dom";

import List from "./list";
import FeeAccounts from "./feeAccounts";
import GST from "./gst";

const FeeBundle = () => {
  const { type } = useParams();

  if (type === "list") return <List />;
  else if (type === 'fee_accounts') return <FeeAccounts/>
  else if (type==='gst') return <GST/>
  return <div>404 Page not found!</div>;
};

export default FeeBundle;
